import { render, staticRenderFns } from "./RequestAdd.vue?vue&type=template&id=5b719ac8&"
import script from "./RequestAdd.vue?vue&type=script&lang=js&"
export * from "./RequestAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports